"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _utils = require("@mulesoft/exchange-ui-portals-store/lib/domains/pages/utils");
var styles = {
  "body": "TermsModal__body__2s_6t",
  "spinner": "TermsModal__spinner__20Pvy",
  "modal": "TermsModal__modal__DY3L8",
  "header": "TermsModal__header__16ns_",
  "footer": "TermsModal__footer__3Qdqt",
  "title": "TermsModal__title__170b6"
}; 
require('./TermsModal.css');
var TermsModal = function TermsModal(props) {
  var _asset$version;
  var apiGroupInstanceId = props.apiGroupInstanceId,
    asset = props.asset,
    isPortalLoading = props.isPortalLoading,
    defaultTermsMarkdown = props.defaultTermsMarkdown,
    termsMarkdown = props.termsMarkdown,
    onComponentMounted = props.onComponentMounted,
    renderUnderlyingTerms = props.renderUnderlyingTerms;
  var labelId = 'terms-modal';
  var terms = termsMarkdown || defaultTermsMarkdown;
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var config = (0, _exchangeReactHooks.useConfig)();
  _react.default.useEffect(function () {
    onComponentMounted();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    className: styles.modal,
    onEsc: function onEsc() {
      return closeModal();
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    testId: "terms-modal",
    ariaLabelledBy: labelId
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    className: styles.modalHeader,
    testId: "terms-modal-header"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: labelId,
    className: styles.title
  }, "Terms and Conditions")), isPortalLoading ? /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    className: (0, _classnames.default)(styles.body, styles.spinner),
    testId: "terms-modal-body"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    center: true,
    size: "l"
  })) : null, !isPortalLoading ? /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    className: styles.body,
    testId: "terms-modal-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: (0, _utils.markdownToHTML)({
        config: config,
        markdown: terms,
        options: {
          minHeaderLevel: 3
        },
        groupId: asset === null || asset === void 0 ? void 0 : asset.groupId,
        assetId: asset === null || asset === void 0 ? void 0 : asset.assetId,
        version: (_asset$version = asset === null || asset === void 0 ? void 0 : asset.version) !== null && _asset$version !== void 0 ? _asset$version : ''
      })
    },
    "data-test-id": "terms-text"
  }), renderUnderlyingTerms({
    apiGroupInstanceId: apiGroupInstanceId
  })) : null, /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "modal-footer"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "close-terms-modal-button",
    kind: "tertiary",
    className: styles.modalButton,
    onClick: function onClick() {
      return closeModal();
    }
  }, "Close")));
};
TermsModal.defaultProps = {
  termsMarkdown: '',
  defaultTermsMarkdown: '',
  renderUnderlyingTerms: function renderUnderlyingTerms() {
    return null;
  }
};
var _default = exports.default = TermsModal;
//# sourceMappingURL=TermsModal.js.map